// extracted by mini-css-extract-plugin
export var backdropBlur = "_mr-0";